import { faCheck, faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Text, View } from '@zinc/ui';
import { Button } from 'bz-core-controls';
import useStore from 'bz-stores/hook/mobx-inject/useStore';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import z from 'z';
import type TerminalPaymentDialogStore from '../../../../stores/terminal-payment-dialog-store';
import TerminalModalCountdown from './controls/terminal-modal-countdown';

export interface IProps {}

const TerminalModalContent: React.FC<IProps> = observer(() => {
  const {
    showUnloadWarning,
    onCancel,
    paymentError,
    processingStatusMessage,
    terminalPaymentSuccessful,
    closeDialog,
    onRetry
  } = useStore<TerminalPaymentDialogStore>('terminalPaymentDialogStore');

  return (
    <View gap={2}>
      {!terminalPaymentSuccessful && !paymentError && (
        <Text variant="caption-1">{processingStatusMessage}</Text>
      )}
      {paymentError || terminalPaymentSuccessful ? (
        <Alert
          icon={<FontAwesomeIcon icon={paymentError ? faTriangleExclamation : faCheck} size="xl" />}
          color={paymentError ? 'critical' : 'positive'}
        >
          <Text color={paymentError ? 'critical' : 'positive'}>
            {paymentError ? 'Payment failed. Please try again.' : 'Payment successful!'}
          </Text>
        </Alert>
      ) : (
        <TerminalModalCountdown />
      )}
      {showUnloadWarning && (
        <Text variant="caption-1" color="critical">
          If you reload the page with a transaction in process, it may result in a payment taken
          against the card, but not registered in {z.word('TM3')}
        </Text>
      )}

      <View direction={'row'} justify={'end'} gap={2}>
        <Button variant="outline" onClick={terminalPaymentSuccessful ? closeDialog : onCancel}>
          {terminalPaymentSuccessful ? 'Close' : 'Cancel'}
        </Button>
        {paymentError && (
          <Button variant="solid" onClick={onRetry}>
            Try Again
          </Button>
        )}
      </View>
    </View>
  );
});

TerminalModalContent.displayName = 'TerminalModalContent';
export default TerminalModalContent;
